import styled from 'styled-components'

export const StyledClozeMathWrapper = styled.div`
  zoom: ${(props) => props.theme.widgets.clozeText.textZoom};
  max-width: 100%;
`
